import { useIntl } from 'react-intl';

import { useAppSelector } from '@verantos-dev/app-state-base';
import { selectCohortDsl } from '@verantos-dev/app-state-cohort-builder';
import { generateUIModelFromDSL } from '@verantos-dev/util-cohort-definition-dsl-to-ui';
import { getFullDslQueryString } from '@verantos-dev/util-cohort-definition-ui-to-dsl';

import { type CohortTranslationProps } from './CohortTranslation';

export const useCohortDefinitionDSLToUISection = (): CohortTranslationProps => {
  const intl = useIntl();
  const fullCohortDSL = useAppSelector(selectCohortDsl);
  const cohortQueryStrings = fullCohortDSL ? getFullDslQueryString(fullCohortDSL).split('\n') : [];
  const hasQueryStringValues = cohortQueryStrings.some((line) => line.length > 0);

  return {
    title: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortDefinitionDSLToUISection.title',
    }),
    emptyStateMainMessage: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLMainMsg',
    }),
    emptyStateSubMessage: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLSubMsg',
    }),
    content: hasQueryStringValues ? (
      <CohortDSLToUIContent cohortQueryStrings={cohortQueryStrings} />
    ) : undefined,
  };
};

const CohortDSLToUIContent = ({ cohortQueryStrings }: { cohortQueryStrings: string[] }) => {
  return (
    <>
      <div>{cohortQueryStrings.join('')}</div>
      <br />
      <div>{JSON.stringify(generateUIModelFromDSL(cohortQueryStrings.join('')))}</div>
    </>
  );
};
